module.exports = __webpack_public_path__ + "static/media/pi.bf1d5683.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cardicons/pi.png
// module id = 1500
// module chunks = 0